import { FC } from "react";
import CmsTextEditorContent from "@Libs/contentful/components/cms-text-editor/CmsTextEditor";
import classes from "@Styles/snippets/_product_disclaimer.module.scss";

export interface IProductDisclaimerProps {
  disclaimerText: {};
}
export const ProductDisclaimer: FC<IProductDisclaimerProps> = ({
  disclaimerText,
}) => {
  return (
    <div className={classes["product-disclaimer__container"]}>
      <span>
        <CmsTextEditorContent content={disclaimerText} />
      </span>
    </div>
  );
};

ProductDisclaimer.defaultProps = {
  disclaimerText: {},
};
